import React from 'react';

const LayoutFooter = () => (
  <footer className="w-full py-6 md:py-8 border-t border-indigo-800 bg-indigo-700 dark:border-teal-800 dark:bg-teal-700">
    <div className="container flex flex-col items-center justify-between gap-4 px-4 md:flex-row md:px-6">
      <div className="text-sm text-white dark:text-gray-200">
        © 2024 EC-Compliance. Todos los derechos reservados. Tu éxito es nuestro compromiso.
      </div>
      <nav className="flex gap-4 sm:gap-6">
        <a href="#servicios" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">Servicios</a>
        <a href="#soluciones" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">Soluciones</a>
        <a href="#contacto" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">Contacto</a>
      </nav>
      <div className="flex gap-4">
        <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-indigo-200 dark:hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
            <rect x="2" y="9" width="4" height="12"></rect>
            <circle cx="4" cy="4" r="2"></circle>
          </svg>
        </a>
        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-indigo-200 dark:hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
          </svg>
        </a>
        <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-indigo-200 dark:hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
          </svg>
        </a>
      </div>
    </div>
  </footer>
);

export default LayoutFooter;